// material-ui
import { useTheme } from '@mui/material/styles';

import defaultLogo from '../assets/images/logo.png';
import useTenantConfig from '../hooks/useTenantConfig';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();
    const { tenantConfig } = useTenantConfig();


    // Usar el logo personalizado si existe, de lo contrario usar el logo por defecto
    const logoUrl = tenantConfig?.logo_url || defaultLogo;


    return (
        <img src={logoUrl} alt="Site_logo" width="120" />
    );
};

export default Logo;
